module.exports = __webpack_public_path__ + "img/inviqa.28b21455.jpeg";